const overseasContactConfigRouter = {
  title: '联系信息管理',
  type: 'view',
  name: 'overseasContactConfig',
  route: '/overseas-contact/config',
  filePath: 'view/overseas_contact_config/index.vue',
  order: 9,
  inNav: true,
  icon: 'iconfont el-icon-phone-outline',
  permission: ['查询平台联系信息'],
}

export default overseasContactConfigRouter
